export default __webpack_public_path__ + "static/media/eventDashboard_fire.6c99c3aa.svg";